// A generated file, substituting in the hashed filename of the iframe-inside code into the full URL
export function getIframeIndexJsUrl() {
  return "https://officefluidprodversionedcdn.azureedge.net/assets/sourceless-iframe/index.42f2d870e86a4131e640.js";
}